import { useCallback } from 'react';
import { useDialogContext } from '@/contexts/dialog-context';
import { useTranslation } from '@/contexts/language-context';

export function usePartnerLoginDialog() {
  const { t } = useTranslation();
  const { addDialog } = useDialogContext();

  return useCallback(() => {
    let deferredResolve;
    const result = new Promise((resolve) => {
      deferredResolve = resolve;
    });

    addDialog({
      title: t('login.partnerDialog.title', 'Registering as a borrower'),
      onClose: () => {
        if (deferredResolve) {
          const fn = deferredResolve;
          deferredResolve = null;
          fn(false);
        }
      },
      content: t(
        'login.partnerDialog.content',
        'You are about to register a new account as a borrower. We detected a partner account with the same email address. Would you like to sign-in to the partner portal instead?'
      ),
      actions: [
        {
          label: t(
            'login.partnerDialog.buttons.registerAsBorrower',
            'Register as Borrower'
          ),
          onClick: () => {
            if (deferredResolve) {
              const fn = deferredResolve;
              deferredResolve = null;
              fn('borrower');
            }
          },
          base: true
        },
        {
          label: t(
            'login.partnerDialog.buttons.signInAsPartner',
            'Sign-in as Partner'
          ),
          onClick: () => {
            if (deferredResolve) {
              const fn = deferredResolve;
              deferredResolve = null;
              fn('partner');
            }
          }
        }
      ]
    });

    return result;
  }, [addDialog, t]);
}
